import {
    bindPopover,
    bindTrigger,
    usePopupState,
} from "material-ui-popup-state/hooks";
import {
    Button, capitalize,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import {useDeleteFreeDay} from "../../client/hooks";
import {useMutation, useQueryClient} from "react-query";
import {enqueueSnackbar} from "notistack";
import {useT} from "../../i18n";

export default function DeleteFreeDaysButton({id}: { id: string }) {
    const mutate = useLoeschenFreiezeit(id);
    const {t: translation} = useT("freedays");
    const popupState = usePopupState({
        variant: "popover",
        popupId: `freeday-${id}-delete`,
    });
    return (
        <>
            <IconButton {...bindTrigger(popupState)} aria-label="delete">
                <DeleteIcon/>
            </IconButton>
            <Dialog {...bindPopover(popupState)}>
                <DialogTitle id="alert-dialog-title">
                    {capitalize(translation("deleteForm.title"))}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {capitalize(translation("deleteForm.description"))}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => popupState.close()} color="inherit">
                        {capitalize(translation("common.cancel"))}
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                            mutate.mutate();
                            popupState.close();
                        }}
                    >
                        {capitalize(translation("common.delete"))}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

function useLoeschenFreiezeit(id: string) {
    const deleteFreeDay = useDeleteFreeDay();
    const queryClient = useQueryClient();
    const {t: translation} = useT("freedays");

    return useMutation(
        () => {
            return deleteFreeDay(id);
        },
        {
            onSuccess: async () => {
                await queryClient.invalidateQueries(["freeDays"]);
                enqueueSnackbar(capitalize(translation("freeDays.deleteSuccess")), {variant: "success"});
            },
            onError: () => {
                enqueueSnackbar(capitalize(translation("freeDays.saveError")), {variant: "error"});
            },
        }
    );
}
